import { QueryObserverResult } from "@tanstack/react-query";
import { ExtractAllEnumKeys } from "../../../../../../react-commons/types/extractKeysOfType";
import { Form_AutocompleteResourceTextField, Form_AutocompleteResourceTextFieldProps } from "./Form_AutocompleteResourceTextField";
import { Except } from "type-fest";
import { QueryBaseComponent } from "../../../../../../react-commons/query/QueryBaseComponent";
import { PersistableResource } from '../../../../resource/resource-base/persistableResourceTypes';

export type Form_AutocompleteReferenceTextFieldProps<
    P extends PersistableResource,
    T extends object,
    TTypeKey extends keyof P & ExtractAllEnumKeys<P>,
    N extends boolean,
> = {
    query: QueryObserverResult<P | Array<P> | { content: P } | { content: Array<P> } | null>;
} & Except<Form_AutocompleteResourceTextFieldProps<T, P, TTypeKey, N>, 'resources'>;

export const Form_AutocompleteReferenceTextField = <
    P extends PersistableResource,
    T extends object,
    TTypeKey extends keyof P & ExtractAllEnumKeys<P>,
    N extends boolean,
>({
      query,
      ...props
  }: Form_AutocompleteReferenceTextFieldProps<P, T, TTypeKey, N>) => {
    return (
        <QueryBaseComponent
            query={query}
            name={props.label ?? 'Resources'}
            disabledContent={<Form_AutocompleteResourceTextField {...props} resources={[]} disabled={true} />}
        >
            {(data) => (
                <Form_AutocompleteResourceTextField {...props} resources={'content' in data ? data.content : data} />
            )}
        </QueryBaseComponent>
    );
};
